import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import AppRouter from './AppRouter';
import Page from './layout/Page';
import { inSiteMaintenance } from './constants/AppConstants';
import { NO_LAYOUT_PAGES, TOP_LEVEL_PAGES } from './constants/AppUrlConstants';
import SiteMaintenance from './pages/Message/SiteMaintenance';
import SkipLink from './layout/SkipLink';

const App = () => {
  const { pathname } = useLocation();
  const topLevelPage = TOP_LEVEL_PAGES.includes(pathname);

  useEffect(() => {
    if (topLevelPage) {
      sessionStorage.removeItem('formData');
    }
  }, [pathname, topLevelPage]);

  if (inSiteMaintenance) {
    return (
      <>
        <SkipLink />
        <Page>
          <SiteMaintenance />
        </Page>
      </>
    );
  }
  // If any entry in NO_LAYOUT_PAGES is a substring of the current pathname
  // then we should NOT use the Page layout. This allows matching
  // `/spcr/review/123` when `SPCR_REVIEW_REPORT_URL` is `/spcr/review`.
  const useLayout = !NO_LAYOUT_PAGES.some((page) => pathname.includes(page));

  return (
    <>
      <SkipLink />
      {useLayout ? (
        <Page>
          <AppRouter />
        </Page>
      ) : (
        <AppRouter />
      )}
    </>
  );
};

export default App;
